import React from "react";
import DashedBorder from "@default/general-components/dashed-border";
import AccessibilityMenu from "./accessibility-menu";
import LanguageSwitch from "@default/js/i18n/language-switch";

const LanguageAndAccessibility = () => (
  <div className="language-and-accessibility navigation-element">
    <DashedBorder blurredBackdrop reverse />
    <AccessibilityMenu />
    <LanguageSwitch />
  </div>
);

export default LanguageAndAccessibility;
